import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public title = 'Dashboard';
  public logado: boolean = false;
  public user: any = {};
  private app: any;
  private layout: any;
  public configUso: any = {};
  public tokenLTM: any = {};

  public urlretorno: string = "";

  public filtroRegionais: any = [];
  public filtroUFs: any = [];
  public filtroEspecialidades: any = [];
  public filtroStatusResgate: any = [];
  public filtroKits: any = [];
  public filtroTags: any = [];

  constructor() {
    this.app = {
      name: "Chiesi ADM",
      description: "icons4u - We Love Marketing",
      year: new Date().getFullYear(),
    };

    // Layout Settings
    // -----------------------------------
    this.layout = {
      isFixed: true,
      isCollapsed: false,
      isBoxed: false,
      isRTL: false,
      horizontal: false,
      isFloat: false,
      asideHover: false,
      theme: null,
      asideScrollbar: false,
      isCollapsedText: false,
      useFullLayout: false,
      hiddenFooter: false,
      offsidebarOpen: false,
      asideToggled: false,
      viewAnimation: "ng-fadeInUp",
    };

    // environment
    // -----------------------------------
    this.configUso = environment.config.prod;

    let res = JSON.parse(localStorage.getItem('USER_DATA')!);
    console.log(res)
    if(res){
      this.user = res;
      this.logado = true;
    }
    if (window.location.href.lastIndexOf("localhost:") !== -1) {
      this.configUso = environment.config.local;
    } else if (window.location.href.lastIndexOf("dev") !== -1) {
      this.configUso = environment.config.dev;
    } else if (window.location.href.lastIndexOf("hom") !== -1) {
      this.configUso = environment.config.hom;
    }
  }

  getAppSetting(name:any) {
    return name ? this.app[name] : this.app;
  }

  getUserSetting(name:any) {
    return name ? this.user[name] : this.user;
  }

  getLayoutSetting(name:any) {
    return name ? this.layout[name] : this.layout;
  }

  setAppSetting(name:any, value:any) {
    if (typeof this.app[name] !== "undefined") {
      this.app[name] = value;
    }
  }

  setUserSetting(name:any, value:any) {
    if (typeof this.user[name] !== "undefined") {
      this.user[name] = value;
    }
  }

  setLayoutSetting(name:any, value:any) {
    if (typeof this.layout[name] !== "undefined") {
      return (this.layout[name] = value);
    }
  }

  toggleLayoutSetting(name:any) {
    return this.setLayoutSetting(name, !this.getLayoutSetting(name));
  }
}
